export async function download(
  axios,
  url,
  params,
  filename,
  onSucess,
  onError
) {
  var form = {
    params: params,
    responseType: "blob"
  };

  var result = await axios
    .get(url, form)
    .then(response => {
      if (!window.navigator.msSaveOrOpenBlob) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename); //or any other extension
        document.body.appendChild(link);
        link.click();
      } else {
        window.navigator.msSaveOrOpenBlob(new Blob([response.data]), filename);
      }
      if (onSucess) onSucess(response);
    })
    .catch(error => {
      if (onError) onError(error);
    });
}
